import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件

export default {
  name: 'AddRecordSpace',
  data () {
    return {
      tableData: [],
      tableTotalRow: 0,
      // 遮罩层
      loading: true,
      // 查询条件
      tableQueryParams: {
        serverId: 0,
        pageNum: 1,
        pageSize: 10
      },
      // 表格选中记录数组
      tableSelectedIds: [],
      // 记录编辑
      addParams: {
        recordTaskId: 0,
        recordSpaceIdCount: 0,
        recordSpaceIds: []
      }
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    recordTaskId: {
      type: Number,
      default: 0
    }
  },
  mixins: [
    convertorMixin
  ],
  mounted () {
    this.getRecordSpaceList()
  },
  methods: {
    // 获取录像空间列表
    getRecordSpaceList() {
      this.$http(this.$api.recordSpaceList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
          }
        }
      )
    },
    // 表格选中记录改变
    handleTableSelectionChange (selection) {
      this.tableSelectedIds = selection.map(item => item.id)
      this.addParams.recordSpaceIdCount = this.tableSelectedIds.length
      this.addParams.recordSpaceIds = this.tableSelectedIds
    },
    // 分页
    handleTableCurrentChange (val) {
      this.tableQueryParams.pageNum = val
      this.getRecordSpaceList()
    },
    // 提交新增记录
    handleModalSubmit () {
      this.addParams.recordTaskId = this.recordTaskId
      this.$http(this.$api.addRecordSpaceForRecordTask, this.addParams).then(res => {
        if (res.code === 200) {
          this.$emit('submit', false)
          this.$refs.table.clearSelection()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        }
      })
    },
    // 取消提交记录
    handleModalCancel () {
      this.$emit('cancel', false)
      this.$refs.table.clearSelection()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/system/recordTask/addRecordSpace/AddRecordSpace.js